module.exports = __webpack_public_path__ + "img/mistakesText7.8c291ce5.png";